"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSource = void 0;
var AuthSource;
(function (AuthSource) {
    AuthSource["STANDARD"] = "STANDARD";
    AuthSource["GOOGLE_AUTH"] = "GOOGLE_AUTH";
})(AuthSource || (exports.AuthSource = AuthSource = {}));
